import { createTheme } from "@mui/material/styles";

// The single source of truth for MUI-based styling across the app - mounted
// once at the root (see App.tsx) so every MUI component anywhere inherits
// it automatically, instead of each page/component creating its own local
// theme. Colors match the site's existing brand palette
// (src/constants/theme.ts), which predates MUI and still backs the
// non-MUI (styled-components/SASS) pages.
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#4b7196",
      dark: "#2b3956",
      light: "#cfe2f3",
    },
    error: {
      main: "#e8464e",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { color: "#2b3956" },
    h2: { color: "#2b3956" },
    h3: { color: "#2b3956" },
  },
  components: {
    // Matches the site's long-standing convention of a red "*" marker on
    // required field labels (MUI's own default asterisk otherwise just
    // inherits the label's color).
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "#e8464e",
        },
      },
    },
  },
});
